import React from "react";
import { Input } from "./input";
import { formatPhoneInput, stripPhone } from "../../utils/phoneUtils";

/**
 * Phone input that auto-formats to 916.232.2332 as the user types.
 * Calls onChange with the raw digits (e.g. "9162322332").
 */
const PhoneInput = ({ value, onChange, ...props }) => {
  const handleChange = (e) => {
    const raw = stripPhone(e.target.value);
    // Limit to 10 digits
    const limited = raw.slice(0, 10);
    onChange(limited);
  };

  return (
    <Input
      type="tel"
      value={formatPhoneInput(value || "")}
      onChange={handleChange}
      {...props}
    />
  );
};

export default PhoneInput;
